import type { LegalDocumentCode } from '@/constants/legal';

export interface LegalDocumentApiResource {
  code: LegalDocumentCode;
  version: string;
  title: string;
  body_html: string;
}

export interface LegalDocument {
  code: LegalDocumentCode;
  version: string;
  title: string;
  bodyHtml: string;
}

export interface LegalDocumentReference {
  code: LegalDocumentCode;
  version: string;
}

export interface PendingLegalDocumentsApiResource {
  documents: LegalDocumentReference[];
}

export function mapApiResourceToLegalDocument(resource: LegalDocumentApiResource): LegalDocument {
  return {
    code: resource.code,
    version: resource.version,
    title: resource.title,
    bodyHtml: resource.body_html,
  };
}
